module.exports = __webpack_public_path__ + "7d088296/img/file-icon.c085e21e.svg";